import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { debugLogActions, debugErrorActions } from "../helpers/debugHelper";

const handleError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001" || body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-flow-reassign-403") {
    Swal.fire(t("titles.error"), t("admin.flowReassignment.adminOnly"), "error");
  }
};

const buildQueryString = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return query ? `preview?${query}` : "preview";
};

export const startPreviewFlowReassignment = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_REASSIGNMENT_START_LOADING, payload: true });

    try {
      const suffix = buildQueryString(filters);
      const resp = await fetchToken(
        const_routes.SCHEMA,
        const_routes.VERSIONV1,
        const_routes.ROUTE_FLOW_REASSIGNMENT,
        suffix
      );
      const body = await resp.json();
      debugLogActions(":: flowReassignmentActions, preview", body);

      if (body.ok) {
        dispatch({ type: types.FLOW_REASSIGNMENT_SET_PREVIEW, payload: body.payload || null });
        return body.payload;
      }

      handleError(body, dispatch);
      dispatch({ type: types.FLOW_REASSIGNMENT_SET_PREVIEW, payload: null });
      return null;
    } catch (error) {
      debugErrorActions(":: flowReassignmentActions, startPreviewFlowReassignment", error);
      Swal.fire(t("titles.error"), t("admin.flowReassignment.previewError"), "error");
      return null;
    } finally {
      dispatch({ type: types.FLOW_REASSIGNMENT_START_LOADING, payload: false });
    }
  };
};

export const startExecuteFlowReassignment = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_REASSIGNMENT_START_LOADING, payload: true });

    try {
      const resp = await fetchToken(
        const_routes.SCHEMA,
        const_routes.VERSIONV1,
        const_routes.ROUTE_FLOW_REASSIGNMENT,
        "execute",
        filters,
        "POST"
      );
      const body = await resp.json();
      debugLogActions(":: flowReassignmentActions, execute", body);

      if (body.ok) {
        dispatch({ type: types.FLOW_REASSIGNMENT_SET_EXECUTE_RESULT, payload: body.payload || null });
        Swal.fire(
          t("titles.success"),
          t("admin.flowReassignment.executeSuccess", {
            updated: body.payload?.summary?.records_updated ?? 0
          }),
          "success"
        );
        return body.payload;
      }

      handleError(body, dispatch);
      return null;
    } catch (error) {
      debugErrorActions(":: flowReassignmentActions, startExecuteFlowReassignment", error);
      Swal.fire(t("titles.error"), t("admin.flowReassignment.executeError"), "error");
      return null;
    } finally {
      dispatch({ type: types.FLOW_REASSIGNMENT_START_LOADING, payload: false });
    }
  };
};

export const clearFlowReassignmentPreview = () => ({
  type: types.FLOW_REASSIGNMENT_CLEAR
});
